import { store } from 'store';
import { isStaff } from './permission';

const { NODE_ENV } = process.env;

export const Debugger = () => {
  if (NODE_ENV === 'development') {
    // eslint-disable-next-line
    debugger;
  }
};

export const logger = (...args) => {
  const isStaffUser = /@(sigob|migob).com.mx/.test(store.getState().auth?.user?.email);
  if (NODE_ENV === 'development' || isStaffUser || isStaff()) {
    // eslint-disable-next-line no-console
    console.log(...args);
  }
};
